export default __webpack_public_path__ + "static/media/home-banner.4fc6ce1d.png";